import AuthService from "../../Components/auth/AuthService";
const Auth = new AuthService()

export const fetchAllVehicles = async () => {
    const response = await Auth.fetch(`/vehicle/vehicles`);
    if (response) {
        return response;
    }
};

export const fetchAllDrivers = async () => {
    const response = await Auth.fetch(`/driver/drivers`);
    if (response) {
        return response;
    }
};
